import React, {Component} from 'react';
import PropTypes from 'prop-types';

import RankAndMagnitudeContainer from '../RankAndMagnitudeChart/RankAndMagnitudeChartContainer';

class TopNRankAndMagnitudeDashboardContainer extends Component {

    static propTypes = {
        numberOfItemsToFilterFor: PropTypes.number.isRequired,
        itemsToFilterCol: PropTypes.object.isRequired
    }

    // constructor(props) {
    //     super(props)
    // }

    _computeFrequency(itemToRank, data) {

        let freq = 0;
        for (let item of data) {
            if (item.includes(itemToRank)) {
                ++freq
            }
        }

        return {
            item: itemToRank,
            noOfRespondents: freq
        }

    }

    computeColumnData(data, colname) {
        if (!data || !colname) return []

        return data.filter((row)=> row[colname] !== undefined).map((datum)=> datum[colname])
    }

      /**
     * 
     * @param {itemsToRank} items to compute distribution for
     * @param {*} data to be used to compute frequency of each item
     */
    computeOverallFrequencyDist(itemsToRank, data) {
        if (!itemsToRank || !data) return []
        return itemsToRank.map(itemToRank=> {
            return this._computeFrequency(itemToRank, data)
        })
    }

    render() {
        
        const colToFilterData = this.computeColumnData(this.props.data, this.props.itemsToFilterCol.name)
        const freqDist = this.computeOverallFrequencyDist(this.props.itemsToFilterCol.categories, colToFilterData).sort((dataPointA, dataPointB)=> dataPointB.noOfRespondents - dataPointA.noOfRespondents)
        const topNDist = freqDist.slice(0, this.props.numberOfItemsToFilterFor)
        const itemsToRankCol = {
            name: this.props.itemsToFilterCol.name,
            categories: topNDist.map(topItem=> topItem.item)
        }
        
       // delete this.props['itemsToFilterCol']
        const containerData = Object.assign({}, this.props, {col: itemsToRankCol})
        console.dir(containerData)

        return <React.Fragment>
                    <RankAndMagnitudeContainer {...containerData} />
               </React.Fragment>
    }

}

export default TopNRankAndMagnitudeDashboardContainer